import { Box, Divider, IconButton, Stack, Typography, useMediaQuery } from "@mui/material";
import BondStatusChip from "../../../components/BondStatusChip";
import { bondNameFormatter } from "../../../utils/formatters";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

const CompoundHeader = ({ bondDetail, copyIsinHandler }) => {

    const upLGScreenSize = useMediaQuery((theme) => theme.breakpoints.up('lg'));

    return (
        <Box>
            {
                bondDetail &&
                <Stack gap={2} alignItems='flex-start'>
                    <Typography variant={upLGScreenSize ? 'h3' : 'h4'} sx={{ fontWeight: 'bold' }}>{bondNameFormatter(bondDetail)}</Typography>
                    <Stack direction="row" gap={2} alignItems="center">
                        {bondDetail && <BondStatusChip status={bondDetail.status} maturity={bondDetail.maturity} chipSize={upLGScreenSize ? 'medium' : 'small'} />}
                        <Divider flexItem orientation="vertical" />
                        <Stack direction="row" gap={1} alignItems="center">
                            <Typography color="text.secondary">{bondDetail.isin}</Typography>
                            <IconButton size="small" color="complementary" onClick={copyIsinHandler}><ContentCopyIcon fontSize="inherit" /></IconButton>
                        </Stack>
                    </Stack>
                </Stack>
            }
        </Box>


    );
};

export default CompoundHeader;